var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.098,46h-4.116V35.671c0-7.158-5.823-12.981-12.981-12.981s-12.981,5.823-12.981,12.981V46h-4.117c-1.104,0-2,0.896-2,2 v23.31c0,1.104,0.896,2,2,2h34.196c1.104,0,2-0.896,2-2V48C67.098,46.896,66.202,46,65.098,46z M39.019,35.671 c0-4.952,4.029-8.981,8.981-8.981s8.981,4.029,8.981,8.981V46H39.019V35.671z M63.098,69.31H32.902V50h4.117h21.963h4.116V69.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.5765c35aa89a671a5f6d7045c7cd3a21.svg";
export { ForwardRef as ReactComponent };